module.exports = __webpack_public_path__ + "static/img/submitted_successfully.60d7a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/submitted_successfully.svg
// module id = HKUX
// module chunks = 11